<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                <v-label class="d-flex flox-grow-0 flex-shrink-1 font-weight-bold">equilibrio</v-label>   
                <v-btn-toggle v-model="measures.auto_balance" mandatory @change="changeLoads" :disabled="preview">
                    <v-btn text>
                        NON AUTOMATICO
                    </v-btn>
                    <v-btn text>
                        AUTOMATICO
                    </v-btn>
                </v-btn-toggle>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <div class="d-flex justify-end py-2" v-if="!preview">
                        <v-btn @click="buildFromCommon()" color="primary">Usa linearità</v-btn>
                        <v-btn class="ml-4" color="primary" @click="convertPlaceholders(measures.items)">Inizio test</v-btn>
                        <v-btn class="ml-4" color="primary" @click="resetValues(measures.items)">Reset</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.addLoad}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index">
                        <td class="table-blocks text-left">
                            <NumericField dense outlined disabled v-model="item.divs" hide-details></NumericField>
                        </td>
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                @input="changeMass(item)"
                                :class="readingWarning(item.mass)"
                                ></NumericField>
                        </td>
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.reading)"
                                :placeholder="readingPlaceholder(item.mass)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                                ></NumericField>
                            </td>
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                                hide-details
                                disabled
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="calcMinRange(item.reading)"
                                ></NumericField>
                        </td>
                        <td class="table-blocks text-right">
                            <NumericField dense outlined v-model="item.mpe" disabled hide-details />
                        </td>
                        <td class="table-blocks text-right">
                            <!-- mettere autocomplete -->
                            <v-autocomplete dense outlined 
                                hide-details 
                                v-model="item.result" 
                                :items="status"
                                item-text="name"
                                item-value="value"
                                :readonly="preview">
                                <template v-slot:selection="data">
                                    <span class="d-flex align-center"><StatusIcon :status="data.item.value" class="pr-2" />{{data.item.name}}</span>
                                </template>
                                <template v-slot:item="data">
                                    <span class="d-flex align-center"><StatusIcon :status="data.item.value" class="pr-2" />{{data.item.name}}</span>
                                </template>
                            </v-autocomplete>
                        </td>
                    </tr>
                </template>           
            </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                </div>        
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>

<script>
import { mobility_item } from '../../../utils/itemBlockSchema';
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {BaseLeg} from "../../../utils/baseLeg"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseLeg],
    data(){
        return {
            status: [
                {name: '', value: 'uncomplete'},
                {name: 'fallito', value: 'failed'},
                {name: 'ok', value: 'done'}
            ],
            common_data: null
        }
    },
    methods: {
        buildMeasures() {
            this.measures = {
                hi_res : 'off',
                auto_balance: this.conf.auto_balance,
                items: [],
                result: 'uncomplete'
            }
            for (let i = 1 ; i <= this.conf.min_readings ; i++){
                let item = mobility_item({})
                this.measures.items.push(item)
            }
            
            this.buildFromCommon()
            // console.log("DEBUG items tare", this.measures)
        },

        changeMass(row){
            if(row.mass != null){
                let range = this.calcMinRange(row.mass)            
                row.divs = Big(row.mass).div(range.e).toFixed(this.precision)
                row.mpe = this.calc_MPE(range,row.mass)
                if(this.measures.auto_balance){
                    row.addLoad = this.round(row.mpe, this.high_precision)
                } else {
                    row.addLoad = this.round(Big(row.mpe).times(0.4), this.high_precision)
                }
            }
        },
        changeLoads(){
            for(let elem of this.measures.items){
                if(this.measures.auto_balance){
                    elem.addLoad = this.round(elem.mpe, this.high_precision)
                } else {
                    elem.addLoad = this.round(Big(elem.mpe).times(0.4), this.high_precision)
                }
            }
        },
        addRow(){
            let item = mobility_item({})
            this.measures.items.push(item)
        },
        buildFromCommon(){
            if(this.data.common_data.linearity && this.measures.items){
                console.log("$$ data ", this.data.common_data.linearity)
                for(let key in this.data.common_data.linearity){
                    if(key != "undefined" && key != null){
                        let value = this.data.common_data.linearity[key].value
                        // console.log("$$ DEBUG NEW KEY", key, value)
                        // this.measures.items[0].mass = value[0].mass
                        // this.measures.items[0].reading = value[0].reading
                        // let len = this.measures.items.length - 1
                        // this.measures.items[len].mass = value[1].mass
                        // this.measures.items[len].reading = value[1].reading
                        // this.changeMass(this.measures.items[0])
                        // this.changeMass(this.measures.items[len])
                        for(let i = 0; i<value.length; i++){
                            this.measures.items[i].mass = value[i].mass
                            this.measures.items[i].reading = value[i].reading
                        }
                        for(let item of this.measures.items){
                            this.changeMass(item)
                        }
                    }
                }
            }
        }
    },
}
</script>
